export default __webpack_public_path__ + "static/media/TTCommons-ExtraBold.22b2a6f5.woff2";